var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.89842 16.3565C4.04325 16.2117 4.2424 16.1272 4.45361 16.1272H23.6077C23.9578 16.1272 24.1328 16.5496 23.8853 16.797L20.1016 20.5808C19.9568 20.7256 19.7576 20.8101 19.5464 20.8101H0.392259C0.0422463 20.8101 -0.13276 20.3877 0.114663 20.1403L3.89842 16.3565Z",
    fill: "url(#paint0_linear_502_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89842 2.22932C4.04929 2.08449 4.24843 2 4.45361 2H23.6077C23.9578 2 24.1328 2.42243 23.8853 2.66985L20.1016 6.45361C19.9568 6.59844 19.7576 6.68293 19.5464 6.68293H0.392259C0.0422463 6.68293 -0.13276 6.2605 0.114663 6.01308L3.89842 2.22932Z",
    fill: "url(#paint1_linear_502_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1016 9.24763C19.9568 9.1028 19.7576 9.01831 19.5464 9.01831H0.392259C0.0422463 9.01831 -0.13276 9.44074 0.114663 9.68816L3.89842 13.4719C4.04325 13.6168 4.2424 13.7012 4.45361 13.7012H23.6077C23.9578 13.7012 24.1328 13.2788 23.8853 13.0314L20.1016 9.24763Z",
    fill: "url(#paint2_linear_502_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_2",
    x1: 21.778,
    y1: -0.260351,
    x2: 8.52178,
    y2: 25.1306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_2",
    x1: 15.9816,
    y1: -3.28648,
    x2: 2.72545,
    y2: 22.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_2",
    x1: 18.8614,
    y1: -1.78308,
    x2: 5.60517,
    y2: 23.6079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.c19802b41da74c34743b394105e595ce.svg";
export { ForwardRef as ReactComponent };